function initShareButtons($container) {
	$container.find(".share-fb-button").on("click touch", function() {
		var url = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent($(this).data("link"));
		window.open(url, "facebook-share", "width=580,height=296");
		return false;
	});

	$container.find(".share-instagram-button").on("click touch", function() {
		var $btn = $(this);
		var link = $btn.data("link");
		navigator.clipboard.writeText(link).then(function() {
			var $toast = $("<span class='copy-toast'>Link copiato! Incollalo su Instagram</span>");
			$btn.css("position", "relative").append($toast);
			setTimeout(function() { $toast.remove(); }, 2500);
		});
		return false;
	});
}

module.exports = initShareButtons;
